import isEmpty from 'lodash/isEmpty';
import React, { Fragment } from 'react';

import { IMGIX_URL } from '../../src/env';
import DetailsRow from './DetailsRow';

const cryptoImgixUrl = `${IMGIX_URL}/global/projects/crypto-power-list/edited`;

const getPersonPhotoUrl = (person) =>
  `${cryptoImgixUrl}/${person.photo}?fmt=webp&w=250&h=250&fit=crop`;

const CryptoPowerlistRow = ({ section, details, setDetails, isOperatorsSection }) => {
  const screenMd = 992;

  const handlePersonClick = (idx) => {
    setDetails(section[idx]);

    // track ahoy click event
    /* eslint-disable no-undef */
    ahoy.start();
    ahoy.track('crypto-powerlist-profile-click', {
      person: section[idx].name,
      user_id: currentUser.id,
      email: currentUser.email,
      page: window.location.pathname,
    });
    /* eslint-enable no-undef */
  };

  const handleClose = () => {
    setDetails({});
  };

  return (
    <div className="CryptoPowerlistRow">
      <div className="profile-row">
        {section.map((person, idx) => (
          <Fragment key={person.rank}>
            <div className="person-container mb3" onClick={() => handlePersonClick(idx)}>
              <div className={`rank ${person.rank >= 10 ? '--extend' : ''}`}>{person.rank}</div>
              <div
                className="portrait-image-container"
                style={{
                  WebkitMaskImage: `url(${getPersonPhotoUrl(person)})`,
                  WebkitMaskSize: '250px auto',
                }}
              >
                <img height={250} width={250} src={getPersonPhotoUrl(person)} />
                <div className="hidden-text">Read More</div>
              </div>
              <div className="person-name">{person.name}</div>
              <div className="person-firm mt1">{person.firm}</div>
            </div>
            {details?.name === person.name && window.innerWidth <= screenMd && (
              <DetailsRow
                details={details}
                handleClose={handleClose}
                isOperatorsSection={isOperatorsSection}
              />
            )}
          </Fragment>
        ))}
      </div>
      {!isEmpty(details) &&
        section.filter(({ name }) => name === details.name).length > 0 &&
        window.innerWidth > screenMd && (
          <DetailsRow
            details={details}
            handleClose={handleClose}
            isOperatorsSection={isOperatorsSection}
          />
        )}
    </div>
  );
};

export default CryptoPowerlistRow;
